export default "__VITE_ASSET__IV0dntJM__"